package com.devi3east.bashbuddy.common.service

class VersionCheckService(
    private val appVersionProvider: AppVersionProvider
) {

    fun requiresUpdate(config: AppConfigResponse): Boolean {
        return when (appVersionProvider.platform) {
            Platform.ANDROID,
            Platform.IOS ->
                appVersionProvider.buildNumber < config.minimumMobileVersion

            else -> false
        }
    }

}